<template>
    <LsDropdown v-model="localValue" :options="options" :track-id="trackId" />
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsScheduleHelpers } from 'ls-vue-common';
import LsDropdown from './LsDropdown.vue';
import LsServiceDetails from '../LsServiceDetails/LsServiceDetails.vue';

export default {
    name: 'LsDropdownServices',
    components: { LsDropdown },
    props: {
        value: VueTypes.any.isRequired,
        services: VueTypes.arrayOf(
            VueTypes.shape({
                __typename: VueTypes.oneOf(['Schedule', 'Recommendation', 'RequiredService'])
                    .isRequired,
                id: VueTypes.string.isRequired,
            }).isRequired.loose
        ).isRequired,
        trackId: VueTypes.string.isRequired,
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        options() {
            return _.map(this.services, (service) => {
                return {
                    value: `${service.__typename},${service.id}`,
                    label: this.serviceName({ service }),
                    component: LsServiceDetails,
                    props: {
                        service,
                        disableTooltip: true,
                    },
                };
            });
        },
    },

    methods: {
        serviceName({ service }) {
            return lsScheduleHelpers.getScheduleServiceName({
                schedule: service,
                nameOnly: true,
            });
        },
    },
};
</script>
